import React from 'react';
import { makeStyles } from '@material-ui/styles';

const useStyles = makeStyles((theme) => ({

  icon:{
    display: 'flex', 
    flexDirection: 'row', 
    justifyContent: 'center',
    alignItems: 'center',
    color:theme.palette.icon.main,
  },

  image:{
    width:"36px",
  }, 

}));




export default function PaymentImage(props) {
  const classes = useStyles();
  const {imageUrl, imageName} = props; 
  

  return (
  <div className = {classes.icon}>
    { 
      <img className ={classes.image} src={imageUrl} alt={imageName}  />
    }
  </div>
  );
}
